import api from "./api.service";
import router from "../router";
import { store } from "../store/store";
import logger from "../utils/logger";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static auth(username, password, distributorId) {
    return this.apiRequest(
      API_SUFFIX + "/api/auth",
      { username: username, password: password },
      "POST",
      false,
      { "X-distributor-id": distributorId }
    )
      .then(() => {
        store.commit("setAuthed", true);
        logger.log("auth.login.success", "Login succeeded", { username, distributorId });
        this.whoAmI(true)
          .then((data) => {
            store.commit("setUserRole", data.roles);
          })
          .catch((error) => {
            logger.error("auth.login.who_am_i_failed", "ERROR at auth step", { error });
            throw new Error(JSON.stringify(error));
          });
      })
      .catch((error) => {
        logger.error("auth.login.failure", "ERROR at auth step", { error });
        throw new Error(JSON.stringify(error));
      });
  }

  static whoAmI(redirectRequired = false) {
    return this.apiRequest(API_SUFFIX + "/api/users/me", {}, "GET").then(
      (data) => {
        store.commit("setUser", data);

        if (redirectRequired && store.getters.getAuthed == true) {
          if (data.enabled) {
            router.push({
              name: "activity-feed",
              params: { performInitialFetch: true },
            });
          } else {
            router.push("/unverifiedprofile/" + data.email);
          }
        }

        return data;
      }
    );
  }

  static logout() {
    this.apiRequest(API_SUFFIX + "/api/me/logout", {}, "GET").then(() => {
      logger.log("auth.logout", "Logout", { username: store.state.user.email });
      store.commit("setUser", {});
      store.commit("setAuthed", false);
    });
  }

  static requestPasswordReset(username, distributorId) {
    return this.apiRequest(
      API_SUFFIX + "/api/password/SendEmail",
      { username: username },
      "POST",
      false,
      { "X-distributor-id": distributorId }
    )
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw error;
      });
  }

  static requestPasswordResetLoggedIn() {
    return this.apiRequest(
      API_SUFFIX + "/api/password/SendEmailLoggedIn",
      {},
      "POST"
    )
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw error;
      });
  }

  static requestDetailsUpdate(userId, firstName, lastName, telephoneNumber) {
    return this.apiRequest(
      API_SUFFIX + "/api/users/UpdateUserDetails",
      {
        Id: userId,
        FirstName: firstName,
        LastName: lastName,
        MobilePhone: telephoneNumber,
      },
      "POST"
    )
      .then(() => {
        return this.whoAmI();
      })
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw error;
      });
  }

  static getUserDetails(uuId) {
    return this.apiRequest(
      API_SUFFIX + "/api/users/UserDetails/" + uuId,
      {},
      "GET"
    );
  }

  static registerNew(userObj) {
    return this.apiRequest(
      API_SUFFIX + "/api/users/register",
      userObj,
      "POST",
      false,
      { "X-distributor-id": userObj.distributorId }
    )
      .then((data) => {
        logger.log("auth.register.success", "Registration succeeded", { email: userObj.email });
        return data;
      })
      .catch((error) => {
        logger.error("auth.register.failure", "Registration failed", { email: userObj.email, error });
        throw error;
      });
  }

  static loadInviteDetails(token, distributorId) {
    return this.apiRequest(
      API_SUFFIX + `/api/users/LoadInviteDetails/${token}`,
      {},
      "GET",
      false,
      { "X-distributor-id": distributorId }
    )
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw error;
      });
  }

  static registerFromInvite(token, userObj) {
    return this.apiRequest(
      API_SUFFIX + "/api/users/registerfrominvite/" + token,
      userObj,
      "POST",
      false,
      { "X-distributor-id": userObj.distributorId }
    )
      .then((data) => {
        logger.log("auth.register_from_invite.success", "Registration from invite succeeded", { token });
        return data;
      })
      .catch((error) => {
        logger.error("auth.register_from_invite.failure", "Registration from invite failed", { token, error });
        throw error;
      });
  }

  static resetPassword(passwordResetObj, distributorId) {
    return this.apiRequest(
      API_SUFFIX + "/api/password/ResetPassword",
      passwordResetObj,
      "POST",
      false,
      { "X-distributor-id": distributorId }
    )
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw error;
      });
  }

  static updatePassword(newPassword, distributorId) {
    return this.apiRequest(
      API_SUFFIX + "/api/password/UpdatePasswordFirstLogin/" + newPassword,
      {},
      "POST",
      false,
      { "X-distributor-id": distributorId }
    )
      .then((data) => {
        store.commit("setChangedPassword", true);
        return data;
      })
      .catch((error) => {
        throw error;
      });
  }


  static resendVerificationEmail(email, distributorId) {
    return this.apiRequest(
      API_SUFFIX +
        "/api/users/ResendVerificationEmail?email=" +
        encodeURIComponent(email),
      {},
      "GET",
      false,
      { "X-distributor-id": distributorId }
    );
  }

  static verifyEmail(token, distributorId) {
    return this.apiRequest(
      API_SUFFIX + "/api/users/VerifyEmail?token=" + encodeURIComponent(token),
      {},
      "POST",
      false,
      { "X-distributor-id": distributorId }
    )
      .then((data) => {
        logger.log("auth.verify_email.success", "Email verification succeeded", { token });
        return data;
      })
      .catch((error) => {
        logger.error("auth.verify_email.failure", "Email verification failed", { token, error });
        throw error;
      });
  }

  static getAll(startAt = 0, numberToGet = 100, searchTerm = -1) {
    return this.apiRequest(
      API_SUFFIX +
        "/api/users/" +
        startAt +
        "/" +
        numberToGet +
        "/" +
        searchTerm,
      {},
      "GET"
    )
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw error;
      });
  }

  static setEnabled(uuId, isEnabled) {
    return this.apiRequest(
      API_SUFFIX + "/api/users/SetEnabled/" + uuId + "/" + isEnabled,
      {},
      "POST"
    )
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw error;
      });
  }

  static getAnalyticsUsers() {
    return this.apiRequest(
      API_SUFFIX + "/api/users/GetAnalytics",
      {},
      "GET"
    ).catch((error) => {
      throw error;
    });
  }

  static getAnalyticsGroups() {
    return this.apiRequest(
      API_SUFFIX + "/api/ForumGroup/GetAnalytics",
      {},
      "GET"
    ).catch((error) => {
      throw error;
    });
  }

  static getAnalyticsPosts() {
    return this.apiRequest(
      API_SUFFIX + "/api/ForumPost/GetAnalytics",
      {},
      "GET"
    ).catch((error) => {
      throw error;
    });
  }

  static myNotifications() {
    return this.apiRequest(API_SUFFIX + "/api/Notification", {}, "GET");
  }

  static markNotificationRead(notificationId) {
    return this.apiRequest(
      API_SUFFIX + "/api/Notification/MarkAsRead/" + notificationId
    );
  }

  static assignOrganisation(orgCode) {
    return this.apiRequest(
      API_SUFFIX + "/api/Users/AssignOrganisation/" + orgCode,
      {},
      "PATCH"
    );
  }
}
